import upcomingBedroomImg from "../../assets/upcoming-project-image/bedroom.png";
import upcomingBedroomAltImg from "../../assets/upcoming-project-image/bedroom2.png";
import upcomingKitchenImg from "../../assets/upcoming-project-image/kitchen.png";
import upcomingLivingDiningImg from "../../assets/upcoming-project-image/living and dinning1.png";
import upcomingLivingDiningAltImg from "../../assets/upcoming-project-image/living and dinning 2.png";
import upcomingReferenceImg from "../../assets/upcoming-project-image/WhatsApp Image 2026-06-18 at 6.27.19 PM.jpeg";

const UpcomingResidentialProject = {
    title: "Upcoming Residential Project",
    category: "Interior Design / Residential",
    facts: [
      { label: "Location", value: "Pune" },
      { label: "Year", value: "Upcoming" },
      { label: "Area", value: "In planning" },
      { label: "Category", value: "Residential Interior" },
      { label: "Services", value: "Full Interiors" },
    ],
    heroImage: upcomingLivingDiningImg,
    heroAlt: "Upcoming residential interior living and dining area",
    overview:
      "An upcoming residential interior planned around a warm living and dining zone, a functional kitchen and calm bedroom spaces. The design direction focuses on practical storage, soft finishes and everyday comfort.",
    fullbleedImage: upcomingLivingDiningAltImg,
  
    fullbleedAlt: "Upcoming residential bedroom interior",
    fullbleedQuote:
      "A home in planning should already feel clear, comfortable and ready for daily life.",
    chapters: [
      {
        eyebrow: "01 - Living",
        title: "Living And Dining",
        body: "The shared living and dining area is planned as the main family zone with warm finishes, clean circulation and a composed visual language.",
        image: upcomingLivingDiningImg,
        alt: "Upcoming project living and dining view",
      },
      {
        eyebrow: "02 - Kitchen",
        title: "Functional Kitchen",
        body: "The kitchen layout focuses on storage, counter workflow and easy movement between cooking, serving and daily use.",
        image: upcomingKitchenImg,
        alt: "Upcoming project kitchen view",
      },
      {
        eyebrow: "03 - Bedroom",
        title: "Calm Bedroom",
        body: "Bedroom spaces are designed with softer tones, practical wardrobes and a restful layout for everyday comfort.",
        image: upcomingBedroomAltImg,
        alt: "Upcoming project bedroom view",
      },
      {
        eyebrow: "04 - Detail",
        title: "Finishing Direction",
        body: "The material direction brings together furniture, wall treatments and lighting so the home feels cohesive from room to room.",
        image: upcomingLivingDiningAltImg,
        alt: "Upcoming project alternate living and dining view",
      },
    ],
    gallery: [
      {
        image: upcomingLivingDiningImg,
        alt: "Upcoming residential living and dining",
        caption: "Living and dining zone with warm material direction",
      },
      {
        image: upcomingLivingDiningAltImg,
        alt: "Upcoming residential living and dining alternate view",
        caption: "Alternate living and dining view with storage focus",
      },
      {
        image: upcomingKitchenImg,
        alt: "Upcoming residential kitchen",
        caption: "Kitchen planning with practical counter workflow",
      },
      // {
      //   image: upcomingBedroomImg,
      //   alt: "Upcoming residential bedroom",
      //   caption: "Bedroom design direction",
      // },
      {
        image: upcomingBedroomAltImg,
        alt: "Upcoming residential bedroom alternate view",
        caption: "Bedroom concept with calm finishes and wardrobe planning",
      },
      {
        image: upcomingReferenceImg,
        alt: "Upcoming residential project reference",
        caption: "Site reference for the upcoming home",
      },
    ],
  };

export default UpcomingResidentialProject;
